import React from 'react'
import './OracleTestimonial.css';
import testimonials from '../data/Oracle/oracle-testimonial.json';
import Modal from '@mui/material/Modal'
import { useState } from 'react';
import HangingMenus from './components/HangingMenus';

const OracleTestimonial = () => {
  const [total_tsmn_cards, set_total_tsmn_cards] = useState(9);
  let testimonial_with_paging_arr = testimonials.slice(0, total_tsmn_cards);
  let total_testimonials = testimonials.length;

  const load_more = () => {
    set_total_tsmn_cards(total_tsmn_cards + 3);
  };

  return (
    <div id="main_container">
      <div className="testi_banner">
        <img
          src={process.env.PUBLIC_URL + '/images/Oracle/oracle_testimonials.png'}
          alt="Oracle-Banner"
          className="img-responsive testimonial-img1"
        />
        <div>
          {/* <h1>Testimonials</h1>
              <span>Hear from our Stakeholders...</span> */}
          {/* <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Odit fuga doloribus vitae commodi quibusdam quas 
                magni quasi dolores neque laudantium.</p> */}
        </div>
      </div>
      <div className="Oracle-tm_feedback">
        <div className="Oracle-testimonial_body">
          {testimonial_with_paging_arr.map((tsmn_obj, index) => {
            return (
              <div className="Oracle-tsmn_cards" key={index}>
                <div className='testi-Header' >
                  <img src={process.env.PUBLIC_URL + '/images/SAP/testimonial/avatar.png'} alt=""  className='profile'/>
                  <div className='tsm-textWrapp'>
                  <h4>{tsmn_obj.name}</h4>
                  <h5 className="Oracle-tsmn_designation">{tsmn_obj.designation}</h5>
                  </div>
                </div>
                <img className="clip" src={process.env.PUBLIC_URL + '/images/SAP/testimonial/clip.png'} alt="" />
                <p>{tsmn_obj.content}</p>
              </div>
            );
          })}
        </div>
        {/* {total_testimonials !== total_tsmn_cards && (
          <div className="Oracle-testimonial_see_more">
            <span onClick={load_more}>See More...</span>
          </div>
        )} */}
      </div>
      <HangingMenus />
    </div>
  )
}

export default OracleTestimonial